import React from "react"
import "./Footer.css"
import logo from "../assets/logo.png"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
 
const Footer = () => {

  const { t, i18n } = useTranslation()


  return (
    <footer>
        <div className="fl-footer">
          <div className={`${i18n.language === "ar" ? "vertical-container-ar" : "vertical-container"}`}>
            <div className={`${i18n.language === "ar" ? "left-footer-container-ar" : "left-footer-container"}`}>
              <div className={`${i18n.language === "ar" ? "logo_container-ar" : "logo_container"}`}>
                <a href="/" className="flex-default">
                  <img src={logo} className="logo-footer" alt="Logo" />
                </a>
                <div className="company_name">
                  The Knowledge Impact
                </div>
              </div>
              <div className="socials">
                <div>
                  <a href="/" aria-label="Email" className="social_link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 22.5 22.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail-icon lucide-mail"><path d="m20.625 6.563 -8.429 5.369a1.875 1.875 0 0 1 -1.883 0L1.875 6.563"/><path x="2" y="4" width="20" height="16" rx="2" d="M3.75 3.75H18.75A1.875 1.875 0 0 1 20.625 5.625V16.875A1.875 1.875 0 0 1 18.75 18.75H3.75A1.875 1.875 0 0 1 1.875 16.875V5.625A1.875 1.875 0 0 1 3.75 3.75z"/></svg>
                  </a>
                </div>
                <div>
                  <a href="/" aria-label="LinkedIn" className="social_link">
                    <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 15 15"><path d="M12.781 12.781h-2.223V9.3c0 -0.83 -0.015 -1.898 -1.156 -1.898 -1.158 0 -1.335 0.905 -1.335 1.838v3.541H5.844V5.623H7.978v0.978h0.03a2.344 2.344 0 0 1 2.105 -1.156c2.253 0 2.668 1.482 2.668 3.41zM3.337 4.644a1.29 1.29 0 1 1 1.289 -1.291A1.29 1.29 0 0 1 3.337 4.644m1.111 8.137H2.224V5.623h2.225zM13.889 0.001H1.107A1.097 1.097 0 0 0 0 1.082v12.835A1.097 1.097 0 0 0 1.107 15h12.782A1.097 1.097 0 0 0 15 13.917V1.081A1.097 1.097 0 0 0 13.889 0" fill="#fff"/></svg>
                  </a>
                </div>
                <div>
                  <a href="/" aria-label="Phone" className="social_link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 22.5 22.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone-icon lucide-phone"><path d="M12.968 15.533a0.938 0.938 0 0 0 1.137 -0.284l0.333 -0.436A1.875 1.875 0 0 1 15.938 14.063h2.813a1.875 1.875 0 0 1 1.875 1.875v2.813a1.875 1.875 0 0 1 -1.875 1.875A16.875 16.875 0 0 1 1.875 3.75a1.875 1.875 0 0 1 1.875 -1.875h2.813a1.875 1.875 0 0 1 1.875 1.875v2.813a1.875 1.875 0 0 1 -0.75 1.5l-0.439 0.329a0.938 0.938 0 0 0 -0.274 1.156 13.125 13.125 0 0 0 5.993 5.985"/></svg>
                  </a>
                </div>
              </div>
            </div>
            <div className={`${i18n.language === "ar" ? "right-footer-container-ar" : "right-footer-container"}`}>
              <div className="container-list-f">
                <ul className="footer-list">
                  <li>
                    {t('footer.cols.one.title')}
                  </li>
                  <li className="fl-list-child">
                    <a href="/">{t('footer.cols.one.our_team')}</a>
                  </li>
                  <li className="fl-list-child">
                    <a href="/">{t('footer.cols.one.our_services')}</a>
                  </li>
                </ul>
              </div>
              <div className="container-list-f">
                <ul className="footer-list">
                  <li>
                    {t('footer.cols.two.title')}
                  </li>
                  <li className="fl-list-child">
                    <a href="/">LinkedIn</a>
                  </li>
                  <li className="fl-list-child">
                    <a href="/">{t('footer.cols.two.our_clients')}</a>
                  </li>
                </ul>
              </div>
              <div className="container-list-f">
                <ul className="footer-list">
                  <li>
                    {t('footer.cols.three.title')}
                  </li>
                  <li className="fl-list-child">
                    <a href="/">{t('footer.cols.three.call_us')}</a>
                  </li>
                  <li className="fl-list-child">
                    <a href="/">{t('footer.cols.three.contact_us')}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={`${i18n.language === "ar" ? "bottom-copy-ar" : "bottom-copy"}`}>
            <div className="copyright">
              &copy; {new Date().getFullYear()} {t('footer.bottom.copy')}
            </div>
            <div className={`${i18n.language === "ar" ? "right-bottom-footer-ar" : "right-bottom-footer"}`}>
              <div className="flex-default-footer">
                <Link to={"/"} className="reserved">
                  {t('footer.bottom.links.privacy_policy')}
                </Link>
              </div>
              <div className="dot">
                ·
              </div>
              <div className="flex-default-footer">
                <Link to={"/"} className="reserved ">
                  {t('footer.bottom.links.terms')}
                </Link>
              </div>
              <div className="dot">
                ·
              </div>
              <div className="flex-default-footer">
                <Link to={"/"} className="reserved">
                  {t('footer.bottom.links.code_of_conduct')}
                </Link>
              </div>
            </div>
          </div>
        </div>
    </footer>
  )
}
 
export default Footer